import {
  Component,
  OnInit,
  ChangeDetectorRef
}
from '@angular/core';

import {
  CommonModule
}
from '@angular/common';

import {
  ActivatedRoute,
  RouterLink
}
from '@angular/router';

import {
  HttpClient
}
from '@angular/common/http';

@Component({
  selector:
    'app-category-products',

  standalone: true,

  imports: [
    CommonModule,
    RouterLink
  ],

  templateUrl:
    './category-products.html',

  styleUrls: [
    './category-products.scss'
  ]
})
export class CategoryProducts
implements OnInit
{
  products: any[] = [];

  loading = false;

  categorySlug = '';

  constructor(
    private route:
      ActivatedRoute,

    private http:
      HttpClient,

    private cdr:
      ChangeDetectorRef
  ) {}

  ngOnInit()
  {
    console.log(
      'CATEGORY COMPONENT LOADED'
    );

    this.categorySlug =
      this.route.snapshot
        .paramMap
        .get('slug')!;

    console.log(
      this.categorySlug
    );

    this.loadProducts();
  }

  loadProducts()
  {
    this.loading = true;

    this.http.get<any[]>(
      `https://lazzaro-api1.onrender.com/api/products/category/${this.categorySlug}`
    )

    .subscribe({

      next: (res) =>
      {
        console.log(
          'API RESPONSE'
        );

        console.log(res);

        this.products = res;

        this.loading = false;

        this.cdr.detectChanges();
      },

      error: (err) =>
      {
        console.log(
          'API ERROR'
        );

        console.log(err);

        this.loading = false;

        this.cdr.detectChanges();
      }
    });
  }
}